import {ScanRepository} from '../repositories/ScanRepository';
import {Service} from '../entities/Service';

export class GetAvailableServicesFromEligibilityUseCase {
  constructor(private readonly scanRepository: ScanRepository) {}

  async execute(caseUserId: number): Promise<Service[]> {
    return await this.scanRepository.getAvailableServicesFromEligibility(caseUserId);
  }
}

